import styles from './ThirdLine.module.css'
import b3 from '../Img/banner/banner_8.png'
import b4 from '../Img/banner/white_2.jpg'
import { useSelector} from "react-redux";
import {ReduxStateInt} from "../Reducer/GlobalReducer";
import { useEffect, useState} from "react";


export default function ThirdLine()
{

    const prefDomain = useSelector((state: ReduxStateInt) => {
        return state.prefDomain
    })

    const [banner, setBanner] = useState<any>(null)


    useEffect(()=>{
        if(!prefDomain || prefDomain.stillLoad) return
        try {
            //console.log("banner ", prefDomain,require("./banner/"+prefDomain?.useBanner))
            console.log("useBanner from pref",prefDomain?.useBanner)
            const x = prefDomain?.useBanner ?  require("../Img/banner/"+prefDomain?.useBanner) : b4
            console.log("useBanner rs",x)

            setBanner(x)

        } catch (e) {
            console.log(e)
            setBanner(b4)
        }

    },[prefDomain])



    return(
        <div className={styles.mainCont}>
            <div className={styles.textCont}
                 //onClick={handleClick}
            >

                    <img src={banner} className={styles.img} alt={"Банер"}/>


            </div>
        </div>
    )
}